import * as core from '../../../../../../../core'

import { query } from './explore-perf-comparison.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.explore.widgets.comparative-performance',
    description:
      'Compares performance across different lenses for dollars and density.',
    name: 'RP Explore - Comparative Performance',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
